var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "tabs" }, on: { leave: _vm.rerender } },
    [
      _vm.ready
        ? _c(
            "div",
            { staticClass: "previous__categories" },
            _vm._l(_vm.categories, function(category, i) {
              return _c("PreviousContestItem", {
                key: i,
                attrs: { category: category }
              })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d47bb30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d47bb30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PreviousContestCategory.vue
// module id = J1Yn
// module chunks = 1